<template>
  <div
    data-qa="exhibition credits page"
    class="text-page white-page"
  >
    <!-- TODO: use the AuthoredHead component here, so it matches the exhibition chapters -->
    <b-container>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          class="col-lg-8 pt-large mb-4"
        >
          <div
            class="context-label"
          >
            {{ $tc('exhibitions.exhibitions', 1) }}
          </div>
          <h2
            v-if="exhibitionTitle"
            class="subtitle"
          >
            {{ exhibitionTitle }}
          </h2>
          <h1>{{ $t('exhibitions.credits') }}</h1>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          class="col-lg-8"
        >
          <article>
            <ShareButton class="mb-4" />
            <SocialShareModal />
            <!-- eslint-disable vue/no-v-html -->
            <div
              data-qa="credits text"
              v-html="htmlCredits"
            />
            <!-- eslint-enable vue/no-v-html -->
          </article>
        </b-col>
      </b-row>
      <b-row
        v-if="hasPartCollection"
        class="justify-content-center mt-3"
      >
        <b-col
          cols="12"
          class="mt-3 col-lg-8"
        >
          <LinkList
            :items="chapterPagesToLinkListItems(hasPartCollection.items, identifier)"
            :title="$t('exhibitions.chapters')"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="relatedLink"
        class="justify-content-center"
      >
        <b-col
          cols="12"
          class="mt-3 col-lg-8"
        >
          <client-only>
            <RelatedCollections
              :entity-uris="relatedLink"
              :title="$t('youMightAlsoLike')"
            />
          </client-only>
        </b-col>
      </b-row>
      <b-row class="footer-margin" />
    </b-container>
  </div>
</template>

<script>
  import { marked } from 'marked';
  import SocialShareModal from '../../../components/sharing/SocialShareModal.vue';
  import ShareButton from '../../../components/sharing/ShareButton.vue';
  import exhibitionChapters from '../../../mixins/exhibitionChapters';

  export default {
    name: 'ExhibitionCreditsPage',
    components: {
      ShareButton,
      SocialShareModal,
      LinkList: () => import('../../../components/generic/LinkList'),
      RelatedCollections: () => import('@/components/related/RelatedCollections')
    },
    mixins: [
      exhibitionChapters
    ],
    beforeRouteLeave(to, from, next) {
      this.$store.commit('breadcrumb/clearBreadcrumb');
      next();
    },

    asyncData({ params, query, error, app, store }) {
      const variables = {
        identifier: params.exhibition,
        locale: app.i18n.isoLocale(),
        preview: query.mode === 'preview'
      };

      return app.$contentful.query('exhibitionCreditsPage', variables)
        .then(response => response.data.data)
        .then(data => {
          if (data.exhibitionPageCollection.items.length === 0) {
            error({ statusCode: 404, message: app.i18n.t('messages.notFound') });
            return null;
          }

          const exhibition = data.exhibitionPageCollection.items[0];

          store.commit('breadcrumb/setBreadcrumbs', [
            {
              text: app.i18n.tc('exhibitions.exhibitions', 2),
              to: app.$path({ name: 'exhibitions' })
            },
            {
              text: exhibition.name,
              to: app.$path({
                name: 'exhibitions-exhibition',
                params: {
                  exhibition: exhibition.identifier
                }
              })
            },
            {
              text: app.i18n.t('exhibitions.credits'),
              active: true
            }
          ]);
          return exhibition;
        })
        .catch((e) => {
          error({ statusCode: 500, message: e.toString() });
        });
    },
    head() {
      return {
        title: this.$pageHeadTitle(this.title),
        meta: [
          { hid: 'title', name: 'title', content: this.title },
          { hid: 'og:title', property: 'og:title', content: this.title },
          { hid: 'og:type', property: 'og:type', content: 'article' }
        ]
      };
    },
    computed: {
      htmlCredits() {
        if (this.credits === undefined) {
          return false;
        }
        return marked.parse(this.credits);
      },
      title() {
        return `${this.name} - ${this.$t('exhibitions.credits')}`;
      },
      exhibitionTitle() {
        return this.name;
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep img {
    display: block;
    margin: 1rem 0;
  }

  ::v-deep .related-collections {
    &.container {
      padding: 0;
    }

    .badge-pill {
      margin-top: 0.25rem;
      margin-right: 0.5rem;
    }
  }
</style>
